import AdBlocker from './AdBlocker';
export default AdBlocker;
